import './TaskBar.css';
import { TaskBarAppIcon } from '../TaskBarAppIcon/TaskBarAppIcon';
import { useState } from 'react';
import AllAppsIcon from 'url:./all_apps.svg';

export function TaskBar({
    appsOpened,
    onOpenClick,
    isMaximized,
    zIndex,
    language,
    onOpenAppGallery,
    handleLanguageChange
}) {

    const [time, setTime] = useState(new Date().toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' }));

    // Update time every minute
    setInterval(() => {
        setTime(new Date().toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' }));
    }, 2000);

    return (
        <div className={`task-bar ${isMaximized ? "task-bar_maximize" : "task-bar_no-maximize"} task-bar_transition`} style={{ zIndex: zIndex }}>
            <div className="task-bar_all-apps">
                <TaskBarAppIcon
                    icon={AllAppsIcon}
                    name="All Apps"
                    onClick={onOpenAppGallery}
                />
            </div>
            <div className="task-bar_open-apps">
                {appsOpened && Object.entries(appsOpened).map(([key, app]) => (
                    <TaskBarAppIcon
                        key={app.pid}
                        icon={app.icon}
                        name={app.title}
                        onClick={onOpenClick(app.pid)}
                        isClosing={app.isClosing}
                    />
                ))}
            </div>
            <div className="task-bar_settings">
                <button
                    className="task-bar_language-button"
                    onClick={handleLanguageChange}
                >
                    {language}
                </button>
                <span className="task-bar_time">
                    {time}
                </span>
            </div>
        </div>
    );
}